import { type TranslationTree } from '@/i18n/types';

export const messages = {
  loadError: 'Não foi possível carregar o convite',
  signIn: 'Entrar',
  goToPortal: 'Ir para o portal',
  switchAccount: 'Sair e entrar com outro e-mail',
  accept: 'Aceitar convite',
  accepted: 'Convite aceito',
  acceptError: 'Não foi possível aceitar o convite. Tente de novo',
  signedOut: {
    hint: 'Entre ou crie sua conta com este e-mail para aceitar.',
    signUp: 'Criar conta',
  },
  wrongEmail: {
    title: 'Este convite é para outro e-mail',
    text: 'Você entrou como {{email}}. Saia e entre com {{inviteEmail}} para aceitar.',
  },
  hasAccount: {
    title: 'Você já tem uma conta de parceiro',
    text: 'Cada pessoa participa de uma conta só. Para aceitar este convite, entre com outro e-mail.',
  },
  notFound: {
    title: 'Este convite não vale mais',
    text: 'O link expirou, já foi usado ou foi retirado. Peça um novo convite a quem enviou.',
  },
} satisfies TranslationTree;
